import { render } from "./mvt-footer.vue?vue&type=template&id=2fe3a061"
import script from "./mvt-footer.js?vue&type=script&lang=js"
export * from "./mvt-footer.js?vue&type=script&lang=js"

import "./mvt-footer.vue?vue&type=style&index=0&id=2fe3a061&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__